import React, { Component } from 'react';
import { Row, Col, TabContent, TabPane, Nav, NavItem, NavLink, Input, Form, Label } from 'reactstrap';
import classnames from 'classnames';
import RevenueManagementServiceTab from './RevenueManagementServiceTab';

class RevenueManagementTabs extends Component {

    constructor(props) {
        super(props);

        this.state = {
            activeTab: 0,
            year: new Date().getFullYear()
        }
        this.yearList = [...new Array(3)].map((item, index) => (parseInt(new Date().getFullYear()) - index));
        this.cb = [];
    }

    componentDidMount = () => {
        this.props.log('RevenueManagementTabs.js/componentDidMount');
    }

    setCallback = (cb) => {
        this.props.log('RevenueManagementTabs.js/setCallback (cb)', cb);
        this.cb.push(cb);
    }

    changeYear = (year) => {
        this.props.log('RevenueManagementTabs.js/changeYear (year)', year);
        this.setState({ year: year }
            , () => this.cb.forEach(cb => cb(year))
        );
    }

    render = () => {
        this.props.info('RevenueManagementTabs.js/render');
        return (

            <Row>
                <Col>
                    <Nav tabs className="px-0">
                        {this.props.services.map((serviceGroup, serviceGroupIndex) => (
                            <NavItem key={serviceGroupIndex}>
                                <NavLink
                                    className={classnames({ active: this.state.activeTab === serviceGroupIndex })}
                                    onClick={() => { this.setState({ activeTab: serviceGroupIndex }); }}>
                                    {serviceGroup.name}
                                </NavLink>
                            </NavItem>
                        ))}
                    </Nav>
                    <TabContent activeTab={this.state.activeTab} className="px-0 py-3 mx-0 mb-3 border-left border-right border-bottom activeInsideTab">
                        {this.props.services.map((serviceGroup, serviceGroupIndex) => (
                            <TabPane tabId={serviceGroupIndex} key={serviceGroupIndex}>
                                <Form inline className='ml-4'>
                                    <Label>
                                        Year
                                        <Input className='ml-2' type="select" value={this.state.year} onChange={(e) => this.changeYear(parseInt(e.target.value))}>
                                            {this.yearList.map(year => (
                                                <option key={year}>{year}</option>
                                            ))}
                                        </Input>
                                    </Label>
                                </Form>
                                <RevenueManagementServiceTab
                                    {...this.props}
                                    serviceGroup={serviceGroup}
                                    year={this.state.year}
                                    yearList={this.yearList}
                                    setCallback={this.setCallback}
                                />
                            </TabPane>
                        ))}
                    </TabContent>
                </Col>
            </Row>
        );
    }
}

export default RevenueManagementTabs;
